import { Outlet } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Sidebar } from "@/components/layout/Sidebar";
import { useAuth } from "@/contexts/AuthContext";

export function DashboardLayout() {
  const { profile, userEmail, enabledFeatures } = useAuth();

  return (
    <div className="flex min-h-dvh overflow-x-hidden bg-black text-white">
      <Sidebar
        userEmail={userEmail}
        fullName={profile?.full_name ?? "User"}
        role={profile?.role ?? "admin"}
        enabledFeatures={enabledFeatures}
      />
      <div className="flex min-h-dvh min-w-0 flex-1 flex-col bg-black pt-14 md:pt-0">
        <Header fullName={profile?.full_name ?? "User"} avatarUrl={profile?.avatar_url ?? ""} />
        <main className="mx-auto w-full min-w-0 max-w-7xl flex-1 px-3 py-4 sm:px-4 md:px-6 md:py-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
